export default class ReservationFormUtils {
  static generatedHours (prefixed = false, maxValue = 12) {
    let hours = [];

    for (let i = 0; i <= maxValue; i++) {
      let hour = i;

      if (prefixed && hour < 10) {
        hours.push('0' + hour);
      } else {
        hours.push(hour);
      }
    }

    return hours;
  }

  static generatedMinutes (prefixed = false) {
    let minutes = [];

    for (let i = 0; i <= 55; i += 5) {
      let minute = i;

      if (prefixed && minute < 10) {
        minutes.push('0' + minute);
      } else {
        minutes.push(minute);
      }
    }

    return minutes;
  }

  static fixDateFormat (dateToFix) {
    return dateToFix.split('-').map(n => parseInt(n, 10) < 10 ? '0' + parseInt(n, 10) : n).join('-');
  }

  static prepareParamsToSend (params, paramsConfig) {
    let result = {};
    let IDs = Object.keys(params);

    for (let i = 0; i < IDs.length; i++) {
      if (params[IDs[i]]) {
        if (Array.isArray(params[IDs[i]])) {
          if (params[IDs[i]].length) {
            result['parameters_' + IDs[i]] = this._getParamValue(IDs[i], params[IDs[i]], paramsConfig);
          }
        } else if (typeof params[IDs[i]] === 'number') {
          result['parameters_' + IDs[i]] = [this._getParamValue(IDs[i], params[IDs[i]], paramsConfig)];
        } else {
          result['parameters_' + IDs[i]] = params[IDs[i]];
        }
      }
    }

    return result;
  }

  static _getParamValue (paramID, valueID, paramsConfig) {
    let result = '';
    paramID = parseInt(paramID, 10);

    if (Array.isArray(valueID)) {
      valueID = valueID.map(val => parseInt(val, 10));
    } else {
      valueID = parseInt(valueID, 10);
    }

    for (let i = 0; i < paramsConfig.length; i++) {
      if (paramsConfig[i].id === paramID) {
        if (paramsConfig[i].type === 'select') {
          let selectedOption = paramsConfig[i].values.filter(val => val.id === valueID);

          if (selectedOption.length) {
            result = selectedOption[0].value;
          }
        } else if (paramsConfig[i].type === 'checkbox') {
          let selectedOptions = paramsConfig[i].values.filter(val => valueID.indexOf(val.id) > -1);

          if (selectedOptions.length) {
            result = [];

            for (let i = 0; i < selectedOptions.length; i++) {
              result.push(selectedOptions[i].value);
            }
          }
        }

        break;
      }
    }

    return result;
  }
};



// WEBPACK FOOTER //
// ./src/components/helpers/ReservationFormUtils.js